import React from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@common/components/modal';
import { Button } from '@common/components/button';
import { Icon } from '@common/components/icon';

type Props = {
  children: React.ReactNode;
  onOpenTemplates: () => void;
  onCreateForm: () => void;
};

export const NewFormModal = ({ children, onOpenTemplates, onCreateForm }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      size="small"
      title={t('forms:create_a_form')}
      content={(
        <div className="NewFormModal">
          <div>
            <div className="NewFormModal__Image">
              <Icon type="add" />
            </div>
            <h3>{t('forms:from_scratch_title')}</h3>
            <div>{t('forms:from_scratch_description')}</div>
            <Button
              type="primary"
              size="large"
              onClick={onCreateForm}
            >
              {t('forms:start_from_scatch')}
            </Button>
          </div>
          <div>
            <div className="NewFormModal__Image">
              <img src="/static/images/form-templates.jpg" alt={t('forms:see_templates')} />
            </div>
            <h3>{t('forms:from_template_title')}</h3>
            <div>{t('forms:from_template_description')}</div>
            <Button
              type="primary"
              size="large"
              onClick={onOpenTemplates}
            >
              {t('forms:see_templates')}
            </Button>
          </div>
        </div>
      )}
    >
      {children}
    </Modal>
  );
};
